import axios from 'axios';
import { v4 as uuid } from 'uuid';

import { apiBase } from '@/constants';
import EventBus from '../../event-bus';

export default {
  state: {
    loadingPromotions: false,
    promotions: [],
    promotionToRemove: {},
    promotionErrors: []
  },
  getters: {
    loadingPromotions(state) {
      return state.loadingPromotions;
    },
    promotionErrors(state) {
      return state.promotionErrors;
    },
    promotions(state) {
      return state.promotions;
    },
    promotionToRemove(state) {
      return state.promotionToRemove;
    }
  },
  mutations: {
    addPromotion(state, payload) {
      const promotion = payload;
      promotion.stats = [
        {
          id: uuid(),
          name: 'Polubienia',
          active: true,
          toggle: true,
          value: parseInt(Math.random() * 1000, 10)
        },
        {
          id: uuid(),
          name: 'Komentarze',
          active: true,
          toggle: true,
          value: parseInt(Math.random() * 1000, 10)
        },
        {
          id: uuid(),
          name: 'Story views',
          active: true,
          toggle: true,
          value: parseInt(Math.random() * 1000, 10)
        }
      ];

      state.promotions.push(promotion);
    },
    clearPromotionErrors(state) {
      state.promotionErrors = [];
    },
    checkStat(state, payload) {
      const promotion = state.promotions.find(x => x.id === payload.promotionId);
      const stat = promotion.stats.find(x => x.id === payload.id);
      stat.active = payload.value;
    },
    deletePromotion(state, id) {
      const { promotions } = state;
      state.promotions = promotions.filter(x => x.id !== id);
    },
    getCurrentProfilePromotions(state, promotions) {
      const expandedPromotions = promotions.map((x) => {
        const expandedPromotion = x;
        expandedPromotion.stats = [
          {
            id: uuid(),
            name: 'Polubienia',
            active: true,
            toggle: true,
            value: parseInt(Math.random() * 1000, 10)
          },
          {
            id: uuid(),
            name: 'Komentarze',
            active: true,
            toggle: true,
            value: parseInt(Math.random() * 1000, 10)
          },
          {
            id: uuid(),
            name: 'Story views',
            active: true,
            toggle: true,
            value: parseInt(Math.random() * 1000, 10)
          }
        ];
        return expandedPromotion;
      });
      state.promotions = expandedPromotions;
      EventBus.$emit('loadPromotions', false);
    },
    pushAddProfileError(state, message) {
      state.promotionErrors.push(message);
    },
    setLoadingPromotions(state, isLoading) {
      state.loadingPromotions = isLoading;
    },
    setPromotionToRemove(state, promotionName) {
      state.promotionToRemove = promotionName;
    }
  },
  actions: {
    createPromotion({ rootGetters, commit, dispatch }, promotion) {
      return new Promise((resolve, reject) => {
        const { profileGuid } = rootGetters;
        const payload = {
          ...promotion,
          accountId: profileGuid
        };
        commit('clearPromotionErrors');
        axios.post(`${apiBase}/promotions`, payload)
          .then((response) => {
            if (response.status === 201) {
              commit('addPromotion', response.data);
              dispatch('showLoadingModal', false);
              resolve(response);
            }
          })
          .catch((err) => {
            if (!err.response) {
              reject(err);
            }

            if (err.response.data.code === 'duplicate_promotions') {
              commit('pushAddProfileError',
                `Promocja: ${promotion.label} już istnieje na tym koncie!`);
              commit('showModal', 'PromotionErrorModal');
            } else {
              commit('pushAddProfileError',
                `Wystąpił nieznany błąd przy tworzeniu promocji.`);
              commit('showModal', 'PromotionErrorModal');
            }
          });
      });
    },
    deletePromotion({ commit }, promotionId) {
      return new Promise((resolve) => {
        commit('clearPromotionErrors');
        axios.delete(`${apiBase}/promotions/${promotionId}`)
          .then((response) => {
            if (!response || response.status !== 204) {
              commit('pushAddProfileError',
                'Wystąpił nieznany błąd przy usuwaniu promocji.');
              commit('showModal', 'PromotionErrorModal');
              return;
            }

            commit('deletePromotion', promotionId);
            commit('hideModal');
            resolve(response);
          })
          .catch(() => {
            commit('pushAddProfileError',
              'Wystąpił nieznany błąd przy usuwaniu promocji.');
            commit('showModal', 'PromotionErrorModal');
          });
      });
    },
    getCurrentProfilePromotions({ commit, getters }) {
      return new Promise((resolve, reject) => {
        commit('setLoadingPromotions', true);
        axios.get(`${apiBase}/promotions/${getters.profileGuid}`)
          .then((response) => {
            if (response.status === 200) {
              commit('setLoadingPromotions', false);
              commit('getCurrentProfilePromotions', response.data);
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }
};
